// Event handler for frequency/onetime selector

function getSelectedVariantId() {
  var variantSelect = document.getElementById('variant_select');
  if (variantSelect && variantSelect.value && variantSelect.value !== '0') {
    return String(variantSelect.value);
  }
  var variantInput = document.querySelector('input[name="id"]');
  if (variantInput && variantInput.value) {
    return String(variantInput.value);
  }
  return null;
}

function getSelectedVariantAvailability() {
  var variantSelect = document.getElementById('variant_select');
  if (variantSelect && variantSelect.value && variantSelect.value !== '0') {
    var selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption) {
      var dataAvailable = selectedOption.getAttribute('data-available');
      if (dataAvailable !== null) {
        return dataAvailable === 'true';
      }
    }
  }

  if (variantSelect && variantSelect.tagName === 'INPUT') {
    var inputAvailable = variantSelect.getAttribute('data-available');
    if (inputAvailable !== null) {
      return inputAvailable === 'true';
    }
  }

  var variantId = getSelectedVariantId();
  if (variantId && typeof variantAvailability !== 'undefined' && variantAvailability[variantId] !== undefined) {
    return variantAvailability[variantId];
  }

  return undefined;
}

function syncPrdAvailableFromVariant() {
  var available = getSelectedVariantAvailability();
  if (typeof available !== 'undefined') {
    prdAvailable = available ? 'true' : 'false';
  }
}

function getAddToCartButtonLabel() {
  syncPrdAvailableFromVariant();
  if (prdAvailable == 'true') {
    return typeof btnTextaddtocart !== 'undefined' ? btnTextaddtocart : 'Add to cart';
  }
  return typeof btnTextsold !== 'undefined' ? btnTextsold : 'Sold out';
}

function updateAddToCartButtonText(price) {
  var btnTextElem = document.querySelector('#AddToCart .loader-button__text') || document.querySelector('#AddToCart');
  if (!btnTextElem || !price) return;
  btnTextElem.innerHTML = getAddToCartButtonLabel() + '&nbsp;-&nbsp;' + price;
}

function initVariantAvailabilityListeners() {
  syncPrdAvailableFromVariant();

  var productForm = document.querySelector('form[is="product-form"]') || document.querySelector('product-form');
  if (productForm && productForm.dataset.availabilityListener !== 'true') {
    productForm.dataset.availabilityListener = 'true';
    productForm.addEventListener('variant:changed', function() {
      setTimeout(syncPrdAvailableFromVariant, 0);
    });
  }

  var variantSelectEl = document.getElementById('variant_select');
  if (variantSelectEl && variantSelectEl.dataset.availabilityListener !== 'true') {
    variantSelectEl.dataset.availabilityListener = 'true';
    variantSelectEl.addEventListener('change', syncPrdAvailableFromVariant);
  }
}

document.addEventListener('DOMContentLoaded', function() {
    initVariantAvailabilityListeners();

    var select = document.getElementById('fbis-select');
    if (!select) return;

    select.addEventListener('change', function() {
        var selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        // 1. Set value to #selling-plan-input
        var sellingPlanInput = document.getElementById('selling-plan-input');
        if (sellingPlanInput) {
            sellingPlanInput.value = selectedOption.value;
        }
        // Update #cnt-sbd text to optnname
        var optnname = selectedOption.getAttribute('optnname');
        var cntSbdElem = document.getElementById('cnt-sbd');
        if (cntSbdElem && optnname !== null) {
            cntSbdElem.textContent = optnname;
        }

        // 2. Get priceprc attribute
        var priceprc = selectedOption.getAttribute('priceprc') || '';
        if (priceprc) {
            var total = parseFloat(priceprc) / 100;
            if (curSymbol == '$') {
                total = curSymbol+total;
            } else {
                total = total+curSymbol;
            }

            priceprc = total;
        }
        // Update AddToCart button text
        updateAddToCartButtonText(priceprc);
        // Update frequency-bundles-item__p text
        var freqPriceElem = document.getElementById('frequency-bundles-item__p');
        if (freqPriceElem) {
            freqPriceElem.innerHTML = priceprc;
        }

        // 3. Get pricecmpprc attribute
        var pricecmpprc = selectedOption.getAttribute('pricecmpprc');
        
        if (pricecmpprc) {
            var total2 = parseFloat(pricecmpprc) / 100;
            if (curSymbol == '$') {
                total2 = curSymbol+total2;
            } else {
                total2 = total2+curSymbol;
            }
            pricecmpprc = total2;

            var cmpElem = document.getElementById('frequency-bundles-item__cp');
            if (cmpElem) {
                cmpElem.innerHTML = pricecmpprc;
            }
        }

        // 4. Get pricedsc attribute
        var pricedsc = selectedOption.getAttribute('pricedsc');
        if (pricedsc) {
            var discElem = document.getElementById('frequency-bundles-item__disc');
            if (discElem) {
                discElem.innerHTML = curdisctxt +'&nbsp;'+ pricedsc+'%';
            }
        }
    });
});

// Click handler for frequency-bundles-item

document.addEventListener('DOMContentLoaded', function() {
    var bundles = document.querySelectorAll('.frequency-bundles-item');
    bundles.forEach(function(bundle) {
        bundle.addEventListener('click', function() {
            // Remove active from all, add to clicked
            bundles.forEach(function(b) { b.classList.remove('active'); });
            this.classList.add('active');

            var frcType = this.getAttribute('frc-type');
            var sellingPlanInput = document.getElementById('selling-plan-input');

            if (frcType === 'otp') {
                var price = this.getAttribute('frc-price') || '';
                let total3 = parseFloat(price) / 100;
                if (curSymbol == '$') {
                    total3 = curSymbol+total3;
                } else {
                    total3 = total3+curSymbol;
                }
                price = total3;
                updateAddToCartButtonText(price);
                if (sellingPlanInput) {
                    sellingPlanInput.value = '';
                }
            } else if (frcType === 'subscr') {
                var select = document.getElementById('fbis-select');
                if (select) {
                    var selectedOption = select.options[select.selectedIndex];
                    if (selectedOption) {
                        var priceprc = selectedOption.getAttribute('priceprc') || '';
                        let total4 = parseFloat(priceprc) / 100;
                        if (curSymbol == '$') {
                            total4 = curSymbol+total4;
                        } else {
                            total4 = total4+curSymbol;
                        }
                        priceprc = total4;
                        var value = selectedOption.value || '';
                        updateAddToCartButtonText(priceprc);
                        if (sellingPlanInput) {
                            sellingPlanInput.value = value;
                        }
                    }
                }
            }
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
    var freqItems = document.querySelectorAll('.frequency-big__item');
    if (!freqItems.length) return;
    freqItems.forEach(function(item) {
        item.addEventListener('click', function() {
            freqItems.forEach(function(i) { i.classList.remove('active'); });
            this.classList.add('active');

            var varid = this.getAttribute('varid') || '';
            // Select option in #variant_select where value == varid
            var variantSelect = document.getElementById('variant_select');
            if (variantSelect && varid) {
                var opt = variantSelect.querySelector('option[value="' + varid + '"]');
                if (opt) {
                    variantSelect.value = varid;
                    var event = new Event('change', { bubbles: true });
                    variantSelect.dispatchEvent(event);
                }
            }

            // Show/hide options in #fbis-select by varid
            var fbisSelect = document.getElementById('fbis-select');
            if (fbisSelect && varid) {
                var options = fbisSelect.querySelectorAll('option');
                options.forEach(function(opt) {
                    if (opt.getAttribute('varid') === varid) {
                        opt.classList.add("visible");
                    } else {
                        opt.classList.remove("visible");
                    }
                });
            }

            var custDropItems = document.querySelectorAll('.frequency-bundles-item__subscr-custdrop-item');
            if (custDropItems && varid) {
                let custDropItemsCNT = 1;
                custDropItems.forEach(function(item){
                    if (item.getAttribute('varid') === varid) {
                        item.classList.add("visible");
                        if (custDropItemsCNT === 1) {
                            item.classList.add("selected");
                        } else {
                            item.classList.remove("selected");
                        }
                        custDropItemsCNT++;
                    } else {
                        item.classList.remove("visible");
                        item.classList.remove("selected");
                    }
                })
            }


            // --- UI and attribute updates for priceprc, pricecmpprc, pricedsc ---
            var priceprc = this.getAttribute('priceprc') || '';
            let total5 = parseFloat(priceprc) / 100;
            if (curSymbol == '$') {
                total5 = curSymbol+total5;
            } else {
                total5 = total5+curSymbol;
            }
            priceprcs = total5;
            updateAddToCartButtonText(priceprcs);
            var poElem = document.getElementById('frequency-bundles-item__po');
            if (poElem && priceprcs) {
                poElem.textContent = priceprcs;
            }
            var otpBundle = document.querySelector('.frequency-bundles-item[frc-type="otp"]');
            if (otpBundle && priceprcs) {
                otpBundle.setAttribute('frc-price', priceprc);
            }

            var pricecmpprc = this.getAttribute('pricecmpprc');
            let total6 = parseFloat(pricecmpprc) / 100;
            if (curSymbol == '$') {
                total6 = curSymbol+total6;
            } else {
                total6 = total6+curSymbol;
            }
            pricecmpprcs = total6;

            var cpoElem = document.getElementById('frequency-bundles-item__cpo');
            if (pricecmpprcs && pricecmpprc > priceprc) {
                if (cpoElem) cpoElem.textContent = pricecmpprcs;
                if (otpBundle) otpBundle.setAttribute('frc-comprice', pricecmpprc);
                cpoElem.classList.add("visible");
            } else {
                if (otpBundle) otpBundle.removeAttribute('frc-comprice');
                cpoElem.classList.remove("visible");
            }

            var pricedsc = this.getAttribute('pricedsc');
            pricedsc =parseInt(pricedsc);
            var discoElem = document.getElementById('frequency-bundles-item__disco');
            if (pricedsc && pricedsc > 0 ) {
                pricedsc = curdisctxt +'&nbsp;'+ pricedsc + '%';
                if (discoElem) discoElem.innerHTML = pricedsc;
                if (otpBundle) otpBundle.setAttribute('frc-discrice', pricedsc);
                discoElem.classList.add("visible");
            } else {
                if (otpBundle) otpBundle.removeAttribute('frc-discrice');
                discoElem.classList.remove("visible");
            }

            var activeBundle = document.querySelector('.frequency-bundles-item.active');
            if (!activeBundle) return;
            var frcType = activeBundle.getAttribute('frc-type');
            var select = document.getElementById('fbis-select');
            if (!select) return;
            var visibleOption = select.querySelector('option.visible');
            if (!visibleOption) return;

            if (frcType === 'subscr') {
                // Select the first visible option
                visibleOption.selected = true;
                // Trigger change event if needed
                var event = new Event('change', { bubbles: true });
                select.dispatchEvent(event);
            } else if (frcType === 'otp') {
                // Click the active bundle
                activeBundle.click();

                // Get price attributes from the first visible option
                var priceprc = visibleOption.getAttribute('priceprc') || '';
                let total8 = parseFloat(priceprc) / 100;
                if (curSymbol == '$') {
                    total8 = curSymbol+total8;
                } else {
                    total8 = total8+curSymbol;
                }
                priceprc = total8;
                
                var pricecmpprc = visibleOption.getAttribute('pricecmpprc') || '';
                let total9 = parseFloat(pricecmpprc) / 100;
                if (curSymbol == '$') {
                    total9 = curSymbol+total9;
                } else {
                    total9 = total9+curSymbol;
                }
                pricecmpprc = total9;

                var pricedsc = visibleOption.getAttribute('pricedsc') || '';
                pricedsc = curdisctxt +'&nbsp;'+ pricedsc + '%';

                // Update text in respective elements
                var pElem = document.getElementById('frequency-bundles-item__p');
                if (pElem) pElem.textContent = priceprc;
                var cpElem = document.getElementById('frequency-bundles-item__cp');
                if (cpElem) cpElem.textContent = pricecmpprc;
                var discElem = document.getElementById('frequency-bundles-item__disc');
                if (discElem) discElem.innerHTML = pricedsc;
            }
            
        });
    });

    
});

// Dropdown functionality for custdrop-selected and custdrop-in
document.addEventListener('DOMContentLoaded', function() {
    var custdropSelected = document.getElementById('custdrop-selected');
    var custdropIn = document.getElementById('custdrop-in');
    
    if (!custdropSelected || !custdropIn) return;
    
    // Initially hide the dropdown
    custdropIn.style.display = 'none';
    
    // Toggle dropdown on click of custdrop-selected
    custdropSelected.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent event from bubbling to document
        if (custdropIn.style.display === 'none' || custdropIn.style.display === '') {
            custdropIn.style.display = 'block';
        } else {
            custdropIn.style.display = 'none';
        }
    });
    
    // Hide dropdown when clicking outside
    document.addEventListener('click', function(e) {
        // Check if click is outside both custdrop-selected and custdrop-in
        if (!custdropSelected.contains(e.target) && !custdropIn.contains(e.target)) {
            custdropIn.style.display = 'none';
        }
    });
});

// Click handler for frequency-bundles-item__subscr-custdrop-item
document.addEventListener('DOMContentLoaded', function() {
    var custdropItems = document.querySelectorAll('.frequency-bundles-item__subscr-custdrop-item');
    var fbisSelect = document.getElementById('fbis-select');
    var custdropSelectedIn = document.getElementById('custdrop-selected-in');
    var custdropIn = document.getElementById('custdrop-in');
    
    if (!custdropItems.length || !fbisSelect) return;
    
    custdropItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.stopPropagation(); // Prevent event from bubbling
            
            // 1. Get optid attribute value
            var optid = this.getAttribute('optid');
            if (!optid) return;
            
            // Find and select option in #fbis-select where optid matches
            var options = fbisSelect.querySelectorAll('option');
            var matchingOption = null;
            for (var i = 0; i < options.length; i++) {
                if (options[i].getAttribute('optid') === optid) {
                    matchingOption = options[i];
                    break;
                }
            }
            
            if (matchingOption) {
                // Select the matching option
                fbisSelect.value = matchingOption.value;
                // Trigger change event to update other elements
                var changeEvent = new Event('change', { bubbles: true });
                fbisSelect.dispatchEvent(changeEvent);
            }
            
            // 2. Get optnname attribute value and update text content
            var optnname = this.getAttribute('optnname');
            if (custdropSelectedIn && optnname !== null) {
                custdropSelectedIn.textContent = optnname;
            }
            
            // 3. Hide custdrop-in
            if (custdropIn) {
                custdropIn.style.display = 'none';
            }
        });
    });
});
